import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { isEmpty } from "lodash";
import "../../settings.styles.css";
import StatusViewEditComponent from "../components/statusViewEditComponent";
import SettingsPanel from "../../components/SettingsPanel";

import DeleteModal from "../../../../Components/Common/DeleteModal";

import { toast } from "react-toastify";

import {
  addNewQuoteStatus,
  addNewQuoteStatusSuccess,
  deleteQuoteStatus,
  deleteQuoteStatusSuccess,
  getQuoteStatusList,
  updateQuoteStatus,
  updateQuoteStatusSuccess,
} from "../../../../store/quote/action";
import { getTaskTemplateList } from "../../../../store/tasksCrmIT/action";
export default function QuotingSettings() {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [activeTab] = useState("1");
  const [deleteStatus, setDeleteStatus] = useState("");
  const [createStatus, setCreateStatus] = useState({
    Name: "New Status",
    CssColourText: "#000000",
    CssColourBackground: "#F4F0F0",
  });

  const { opportunitiesStatusListAPI } = useSelector((state) => ({
    opportunitiesStatusListAPI: state.Quote.quoteStatusList?.quotestatus_list,
  }));

  const handleCreateNewStatus = () => {
    if (activeTab === "1") {
      //   Status create
      dispatch(addNewQuoteStatus([createStatus]));
    }
  };

  useEffect(() => {
    let data = [];
    if (activeTab === "1") {
      data = opportunitiesStatusListAPI?.sort((a, b) => b.Id - a.Id);
    }

    setStatusList(data);
  }, [opportunitiesStatusListAPI, activeTab]);

  useEffect(() => {
    dispatch(getQuoteStatusList());
    dispatch(getTaskTemplateList());
  }, []);

  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteStatus = () => {
    if (activeTab === "1") {
      //   Status delete
      dispatch(deleteQuoteStatus([deleteStatus]));
    }
  };
  const [updateItemStatus, setUpdateItemStatus] = useState({});

  // Update Module
  useEffect(() => {
    if (isEmpty(updateItemStatus)) return;
    let updateNewStatus = {
      Id: updateItemStatus?.Id,
      Name: updateItemStatus?.Name,
      CssColourBackground: updateItemStatus?.CssColourBackground,
      CssColourText: updateItemStatus?.CssColourText,
      FlagTriggerTaskCreation: updateItemStatus?.FlagTriggerTaskCreation,
      TriggerTaskCreationTaskTemplateId:
        updateItemStatus?.TriggerTaskCreationTaskTemplateId,
      FlagComplete: updateItemStatus?.FlagComplete,
    };
    const delayUpdate = setTimeout(() => {
      if (activeTab === "1") {
        //  Status update
        dispatch(updateQuoteStatus([updateNewStatus]));
      }
    }, 500);
    return () => clearTimeout(delayUpdate);
  }, [updateItemStatus]);

  const {
    addNewQuoteStatusSuccessAPI,
    deleteQuoteStatusSuccessAPI,
    updateQuoteStatusSuccessAPI,
  } = useSelector((state) => ({
    addNewQuoteStatusSuccessAPI: state.Quote.addQuoteStatusSuccess,
    deleteQuoteStatusSuccessAPI: state.Quote.deleteQuoteStatusSuccess,
    updateQuoteStatusSuccessAPI: state.Quote.updateQuoteStatusSuccess,
  }));
  // Add new Quote Status
  useEffect(() => {
    if (isEmpty(addNewQuoteStatusSuccessAPI)) return;
    if (addNewQuoteStatusSuccessAPI.status === 200) {
      toast.success(addNewQuoteStatusSuccessAPI?.message);
      dispatch(getQuoteStatusList());
    } else {
      toast.error(addNewQuoteStatusSuccessAPI?.message);
    }
    dispatch(addNewQuoteStatusSuccess([]));
  }, [addNewQuoteStatusSuccessAPI]);

  // Delete Quote Status
  useEffect(() => {
    if (isEmpty(deleteQuoteStatusSuccessAPI)) return;
    if (deleteQuoteStatusSuccessAPI.status === 200) {
      toast.success(deleteQuoteStatusSuccessAPI?.message);
      dispatch(getQuoteStatusList());
      setDeleteModal(false);
    } else {
      toast.error(deleteQuoteStatusSuccessAPI?.message);
    }
    dispatch(deleteQuoteStatusSuccess([]));
  }, [deleteQuoteStatusSuccessAPI]);

  // Update Quote Status
  useEffect(() => {
    if (isEmpty(updateQuoteStatusSuccessAPI)) return;
    if (updateQuoteStatusSuccessAPI.status === 200) {
      toast.success(updateQuoteStatusSuccessAPI?.message);
      dispatch(getQuoteStatusList());
    } else {
      toast.error(updateQuoteStatusSuccessAPI?.message);
    }
    dispatch(updateQuoteStatusSuccess([]));
  }, [updateQuoteStatusSuccessAPI]);
  const { taskTemplateListAPI } = useSelector((state) => ({
    taskTemplateListAPI: state.TasksCrmIt?.taskTemplateList?.tasktemplate_list,
  }));
  return (
    <>
      {deleteModal && (
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteStatus}
          onCloseClick={() => {
            setDeleteModal(false);
          }}
        />
      )}

      <SettingsPanel
        title="Quoting Settings"
        description="Statuses used to track quotes through their lifecycle"
      >
        <StatusViewEditComponent
          statusList={statusList}
          setStatusList={setStatusList}
          createStatus={createStatus}
          setCreateStatus={setCreateStatus}
          handleCreateNewStatus={handleCreateNewStatus}
          setDeleteStatus={setDeleteStatus}
          setDeleteModal={setDeleteModal}
          setUpdateItemStatus={setUpdateItemStatus}
          taskCustomStatus={true}
          taskTemplateList={taskTemplateListAPI}
        />
      </SettingsPanel>
    </>
  );
}
